<template>
  <div class="coin-record">
    <div class="coin-index-header">
      {{ titleText }}
      <span class="line" />
    </div>
    <!-- <header-link :link="headerLink"></header-link> -->
    <div class="coin-record-header">
      <span
        v-if="permissions['Coin_Record_Org']"
        :class="{ active: isActive === 1}"
        @click="setActive(1)"
      >組別賬戶</span>
      <span
        v-if="permissions['Coin_Record_Org']"
        class="line"
      />
      <span
        v-if="permissions['Coin_Record_Individual']"
        :class="{ active: isActive === 2}"
        @click="setActive(2)"
      >個人賬戶</span>
      <!-- <span
        @click="setActive(item.id)"
        v-for="item in headerLink"
        :key="item.id"
        :class="{ active: isActive === item.id}"
      >{{item.name}}</span>-->
    </div>
    <div class="coin-main">
      <!-- <router-view></router-view> -->
      <org-account v-if="isActive === 1" />
      <personal-account v-if="isActive === 2" />
    </div>
  </div>
</template>
<script>
import headerLink from "./components/headerLink";
import orgAccount from "./record/organization";
import personalAccount from "./record/personal";
import { mapState } from "vuex";
export default {
  name: "CoinRecord",
  components: {
    headerLink,
    orgAccount,
    personalAccount
  },
  data() {
    return {
      // headerLink: [
      //   {
      //     name: "組別賬戶",
      //     id: 1,
      //     permissionsCode: "Coin_Record_Org"
      //   },
      //   {
      //     name: "個人賬戶",
      //     id: 2,
      //     permissionsCode: "Coin_Record_Individual"
      //   }
      // ],
      isActive: 0,
      roleId: 0,
      titleText:'',
      // currentPermission: ["Coin_Record_Org", "Coin_Record_Individual"] //组织账户,个人账户
    };
  },
  created() {
    if (this.permissions["Coin_Record_Org"]) {
      this.isActive = 1;
    } else if (
      !this.permissions["Coin_Record_Org"] &&
      this.permissions["Coin_Record_Individual"]
    ) {
      this.isActive = 2;
    }
    this.axios.get(this.pub.getApi().GetCompanyCofig).then(res => {
      if (res.data.code === 0 && res.data.result) {
          let isUsedCoin = res.data.result.isUsedCoin;
          let isUsedDiamond = res.data.result.isUsedDiamond;
          this.titleText = isUsedCoin && isUsedDiamond ? '金幣/鑽石記錄' : isUsedDiamond ? '鑽石記錄' : '金幣記錄';
      }
    });
    // if (
    //   this.permissions["Coin_Record_Org"] &&
    //   !this.permissions["Coin_Record_Individual"]
    // ) {
    //   this.headerLink.splice(1, 1);
    //   this.isActive = this.headerLink[0].id;
    // }
    // if (
    //   !this.permissions["Coin_Record_Org"] &&
    //   this.permissions["Coin_Record_Individual"]
    // ) {
    //   this.headerLink.splice(0, 1);
    //   this.isActive = this.headerLink[0].id;
    // } else {
    //   this.isActive = this.headerLink[0].id;
    // }
  },
  methods: {
    setActive(val) {
      this.isActive = val;
    }
  },
  computed: {
    ...mapState(["userInfo", "permissions"])
  }
  // beforeRouteEnter(to, from, next) {
  //   // ...
  //   next(vm => {
  //     if (vm.roleId === 3) {
  //       vm.$router.push("/coin/record/organization");
  //     } else {
  //       vm.$router.push("/coin/record/personal");
  //     }
  //   });
  // }
};
</script>
<style lang="less" scpoed>
@import "../../assets/css/element-reset.less";
.coin-record {
  text-align: left;
  .coin-index-header {
        padding-bottom: 24px;
        font-size: 24px;
        color: #171725;
        .line {
            display: inline-block;
            width: 1px;
            height: 22px;
            background-color: #979797;
            position: relative;
            top: 3px;
            margin: 0 14px;
            visibility: hidden;
        }
    }
  // height: 100%;
  .coin-record-header {
    padding-bottom: 24px;
    span {
      display: inline-block;
      // margin-right: 60px;
      font-size: 24px;
      color: #92929d;
      letter-spacing: 0.1px;
      cursor: pointer;
    }
    span.active {
      color: #171725;
    }
    .line {
      width: 1px;
      height: 22px;
      background-color: #979797;
      position: relative;
      top: 3px;
      margin: 0 14px;
    }
  }
  .coin-main {
    padding-bottom: 20px;
  }
}
</style>